/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

export default freeGlobal;



//////////////////
// WEBPACK FOOTER
// /app/node_modules/lodash-es/_freeGlobal.js
// module id = 567
// module chunks = 1